import { imageUrl } from "../../utils/imageUrl";

const DetailsImage = ({ image, active, onClick }) => {
  if (!image) {
    return null;
  }

  return (
    <button
      type="button"
      className={`details-thumb ${active ? "active" : ""}`}
      onClick={onClick}
      aria-label="نمایش تصویر محصول"
    >
      <img src={imageUrl(image)} alt="تصویر محصول" loading="lazy" />
    </button>
  );
};

export default DetailsImage;
